import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const PhoneWrapper = styled.div`
  margin-bottom: ${theme.space_size};
  width: 100%;
  * {
    direction: rtl !important;
  }
  label {
    span {
      color: ${theme.colours.error};
      font-size: 15px;
    }
    p {
      font-family: ${theme.fonts.Medium};
      color: ${theme.colours.blackText};
      font-size: 14px;
      display: inline-block;
      margin-bottom: 4px !important;
      padding-inline-start: 12px;
      &:lang(en) {
        text-align: left !important;
      }
      &:lang(ar) {
        text-align: right !important;
      }
    }
  }

  .mantine-Select-root.hasError .mantine-Select-input {
    border: 1px solid ${theme.colours.error} !important;
  }

  .hasError {
    .react-select__control {
      border: 1px solid ${theme.colours.error} !important;
      &:lang(en) {
        border-right: none !important;
      }
      &:lang(ar) {
        border-left: none !important;
      }
    }
  }

  .code-input {
    .react-select__input {
      border: none !important;
    }
    .react-select__indicator-separator {
      display: none;
    }
    .react-select__indicator {
      padding: 8px 3px;
    }
    .react-select__control {
      width: 110px;
      max-width: 110px;
      height: 32px;
      min-height: 32px;
      background-color: rgba(245, 245, 245, 1);
      border-radius: 0;
      border: 1px solid rgb(200, 200, 200);
      border-right: 0;
      box-shadow: none !important;
      @media (max-width: 767px) {
        width: 100px;
        max-width: 100px;
      }
      border-top-left-radius: 6px !important;
      border-bottom-left-radius: 6px !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      .react-select__value-container {
        padding-block: 0;
        padding: 0 7px;
        margin-top: -4px;
        .react-select__placeholder {
          font-size: 14px;
        }
        .react-select__input-container {
          padding: 0;
          margin: 0;
          .react-select__input {
            border: none;
            background-color: transparent !important;
            /* background-color: rgb(243,244,246) !important; */
          }
        }
        .react-select__single-value {
          font-size: 14px;
        }
      }
    }
    .react-select__menu {
      font-size: 14px;
      width: 220px !important;
    }
    img {
      display: inline-block;
      width: 24px;
      height: 31px;
      vertical-align: middle;
      border-radius: 16px;
      margin-left: 4px;
    }
  }
  .phone_number {
    input {
      border-bottom-left-radius: 0 !important;
      border-top-left-radius: 0 !important;
      height: 32px;
      text-align: left !important;
      &:lang(en) {
        &::placeholder {
          text-align: left !important;
        }
      }
      &:lang(ar) {
        &::placeholder {
          text-align: right !important;
        }
      }
    }
  }
`;
